import React from 'react';
import { Card, CardBody, CardFooter, CardTitle, Row, Col, Nav } from 'reactstrap';

//Componentes auxiliares:
import HyperlinkLabel from './HyperlinkLabel';
import OptionsDropwdown from './OptionsDropwdown';
import ExecuteScratchButton from './ExecuteScratchButton';
import ButtonWithStatusModal from './ButtonWithStatusModal';
import Grid from '@material-ui/core/Grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//Scripts auxiliares:
import { getSourceTitleText, getSourceSubtitleText, getDataValidityPeriod } from '../../../views/common/downloadSourcesRenderingFunctions';

let dateFormatter = require('../../../tools/formatters/dateFormatter');

//Estilos base:
let paragraphBaseStyle = { textTransform: "none", marginBottom: 0, paddingTop: 5 };
let oneLineParagraphBaseStyle = { textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" };
let footerMessageStyle = { ...paragraphBaseStyle, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" };

let DownloadSourceResumeCard = (props) => {
    return (
        <Col xl="6" lg="6" md="6" sm="6"
            data-tut={(props.downloadSource.index === 1)
                ? "reactour__downloadSourcesResume.downloadSourceCard" : ""}>
            <Card className="card-stats" style={{
                background: "linear-gradient(rgba(255,255,255,.925), rgba(255,255,255,.925))," +
                    "url('" + props.downloadSource.source_logo + "') no-repeat",
                backgroundSize: "125%",
                backgroundPosition: "0% 50%",
            }}>
                <CardBody>
                    <Row>
                        <Col md="4" xs="5" title="Detalle de la descarga"
                            data-tut={(props.downloadSource.index === 1)
                                ? "reactour__downloadSourcesResume.downloadSourceCardStatusButton" : ""}>

                            <ButtonWithStatusModal context="última descarga"
                                targetProcess={props.downloadSource.source_process[0]}
                                downloadSource={props.downloadSource}
                                getStatusButtonClassname={props.getStatusButtonClassname}
                                getStatusIconClassname={props.getStatusIconClassname}
                                getDownloadSourceTitle={props.getDownloadSourceTitle}
                                getTimelineDivClassname={props.getTimelineDivClassname}
                                getTimelineIconClassname={props.getTimelineIconClassname}
                                cancelDownloadProcess={props.cancelDownloadProcess}
                                retryDownloadProcess={props.retryDownloadProcess}>

                                <div className="icon-big text-center icon-warning">
                                    <i className={props.getStatusIconClassname(props.downloadSource)} />
                                </div>

                                <p style={{ ...paragraphBaseStyle, ...oneLineParagraphBaseStyle, textAlign: "center" }}>
                                    <b>{props.getDownloadSourceTitle(props.downloadSource)}</b>
                                </p>
                            </ButtonWithStatusModal>
                        </Col>

                        <Col md="8" xs="7">
                            <div style={{ marginbottom: 0}} className="numbers" data-tut={(props.downloadSource.index === 1)
                                ? "reactour__downloadSourcesResume.downloadSourceCardTitle" : ""}>

                                {false && 
                                    <p className="card-category" style={{ textTransform: "none" }}>
                                        {getSourceSubtitleText(props.downloadSource.description, "-", false)}
                                    </p>
                                }

                                <CardTitle style={{ marginbottom: 20}}>
                                    <p style={{ ...oneLineParagraphBaseStyle }} title={props.downloadSource.description}>
                                        {getSourceTitleText(props.downloadSource.description)}
                                    </p>
                                </CardTitle>
                            </div>

                            <div data-tut={(props.downloadSource.index === 1)
                                ? "reactour__downloadSourcesResume.downloadSourceCardHyperlink" : ""}>
                                <HyperlinkLabel urlTarget={props.getScratchUrl(props.downloadSource)} style={{ ...oneLineParagraphBaseStyle, textAlign: "right" }} />
                            </div>                                
                        </Col>
                    </Row>
                </CardBody>

                <CardFooter>
                    <hr />
                    <Row>
                        <Col md="6" data-tut={(props.downloadSource.index === 1)
                            ? "reactour__downloadSourcesResume.downloadSourceCardLastExecutionDate" : ""}>

                            {
                                getFooterTabs(props.downloadSource)
                            }
                            {
                                //getUIParametrizationComponents(props.downloadSource)
                            } 

                        </Col>
                        <Col md="6">
                            <Nav style={{ justifyContent: "flex-end" }}>
                                <div data-tut={(props.downloadSource.index === 1)
                                    ? "reactour__downloadSourcesResume.downloadSourceCardExecutionButton" : ""}>
                                    <ExecuteScratchButton textStyle={{ marginLeft: 10 }}
                                        downloadSource={props.downloadSource}
                                        onClick={props.executeScratchOnClick} />
                                </div>
                                
                                <OptionsDropwdown
                                    downloadSource={props.downloadSource}
                                    reloadSourcesMethod={props.reloadSourcesMethod} />
                            </Nav>
                        </Col>
                    </Row>
                </CardFooter>
            </Card>
        </Col >
    );
}

let getUIParametrizationComponents = (downloadSource) => {
    let components = [];
    if(downloadSource.name === 'deudores_alimentarios'){
        //console.log(` downloadSource.source_process  ${JSON.stringify(downloadSource.parametrization.processes)}`);
        return downloadSource.parametrization.processes.map((process) => {
            if(process.type === 'scratch_v2'){
                return process.scratches.map((scratch) => {                    
                        return <Grid item xs={false} sm={4} md={7}  style={{fontSize:12, height:15, }}>
                                <Row style={{width:250}}>
                                    {processScratch(scratch)}
                                </Row>
                        </Grid>
                    
                })
            }
    });
    }
    //return components;
}

let processScratch = (scratch) => {
    return scratch.actions.map((action) => {
        return getUIControl(action)
    });
}

let getUIControl = (action) => {
    if(action.event.event_type === 'ui_control'){
        if(action.event.component_type === 'datepicker'){
            return getDatePicker(action.event)
        }
    }
}
let getDatePicker = (event) => {
    return <Col md="6" xs="7" style={{width:35}}>
            <p className="card-category" style={{ textTransform: "none", fontSize:12 }}>
                {event.label}
            </p>
            <DatePicker
                style={{fontSize:12, height:10, }}
                selected={new Date()}
                onSelect={()=>{ 

                }} //when day is clicked
                onChange={() => {

                }} //only when value has changed
            />
        </Col>        
}



let getFooterMessageForDataPeriod = (downloadSource) => {
    if (downloadSource.source_process[0]) {
        const period = getDataValidityPeriod(downloadSource.source_process[0], null);
        if (period) {
            return (
                <span>
                    {period}
                </span>
            );
        }
        return null;
    }
    else {
        return null;
    }
}

let getFooterTabs = (downloadSource) => {
    let outMessage = "";

    if (downloadSource.task_programming.periodic_task !== "") {
        if (downloadSource.next_execution_date) {
            outMessage = getNextDownloadLabel(downloadSource);
        }
    }

    if (outMessage === "") { outMessage = getLastDownloadLabel(downloadSource); }

    console.log('NSALAZAR. downloadSource --> ', downloadSource);
    let period = getFooterMessageForDataPeriod(downloadSource);
    return (
        <React.Fragment>
            <p className="category mbr-15" style={{ ...footerMessageStyle }}
                dangerouslySetInnerHTML={{ __html: outMessage }} />
            {
                period && 
                    <p className="category mbr-15" style={{ ...footerMessageStyle }}>
                        <b>Periodo: </b>
                        {period}
                    </p>               
            }
        </React.Fragment>
    );
}

let getLastDownloadLabel = (downloadSource) => {
    let audio = new Audio("https://audio-previews.elements.envatousercontent.com/files/92048309/preview.mp3");
    let outMessage = "";
    if (downloadSource.source_process.length > 0) {
        switch (downloadSource.source_process[0].status) {
            case "SUCCESS":
            case "WARNING":
                outMessage = "Última descarga terminada en: <b>"
                    + dateFormatter.getShortDate(new Date(downloadSource.source_process[0].end_date || downloadSource.source_process[0].modified))
                    + "</b> a las " + dateFormatter.getShortHour(new Date(downloadSource.source_process[0].end_date || downloadSource.source_process[0].modified));
                break;
            case "PAUSED":
            case "QUEUE_PENDING":
            case "IN_PROCESS":
                outMessage = "Proceso de descarga iniciado en: <b>" + dateFormatter.getShortDate(new Date(downloadSource.source_process[0].created))
                    + "</b> a las " + dateFormatter.getShortHour(new Date(downloadSource.source_process[0].created));
                break;
            case "WAITING_FOR_USER_ACTION":
                //audio.play();
                outMessage = "Esperando accion del usuario desde: <b>" + dateFormatter.getShortDate(new Date(downloadSource.source_process[0].created))
                    + "</b> a las " + dateFormatter.getShortHour(new Date(downloadSource.source_process[0].created));
                break;                
            case "CANCELLED":
                outMessage = "Proceso de descarga cancelado en: <b>" + dateFormatter.getShortDate(new Date(downloadSource.source_process[0].created))
                    + "</b> a las " + dateFormatter.getShortHour(new Date(downloadSource.source_process[0].created));
                break;
            case "ERROR":
                outMessage = "Proceso de descarga fallido en: <b>" + dateFormatter.getShortDate(new Date(downloadSource.source_process[0].end_date))
                    + "</b> a las " + dateFormatter.getShortHour(new Date(downloadSource.source_process[0].end_date));
                break;
            default:
                outMessage = "";
                break;
        }
    }
    else {
        outMessage = "No hay ejecuciones previas";
    }

    return outMessage;
}

let getNextDownloadLabel = (downloadSource) => {
    let nextDate = downloadSource.next_execution_date;

    let outMessage = "Próxima descarga <b>automática</b> en: ";
    outMessage += dateFormatter.getShortDate(new Date(nextDate)) + "</b>";
    outMessage += " a las " + dateFormatter.getShortHour(new Date(nextDate));

    return outMessage;
}

export default DownloadSourceResumeCard;